import React, { Component } from 'react';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';

class Press extends Component {
  static propTypes = {

  };


  constructor(props){
    super(props)
    this.state = {
      newsItems: [
        {title: 'Se inaugura nueva Estación Intermodal en Franklin',date: '10 de febrero de 2020',details: 'La nueva infraestructura, que comienza a funcionar este miércoles 12 de febrero, permitirá a los usuarios transbordar entre l...',image: '/images/news/cnn.png',alt: 'TRANSLATIONS.CNN'},
        {title: 'Plan de transporte que se implementará para el mes de enero',date: '16 de enero de 2020',details: 'Se mantienen los servicios de apoyo a Metro y las extensiones de servicios en aquellos sectores donde aún hay estaciones cerr...',image: '/images/news/el.png',alt: 'TRANSLATIONS.EL'},
        {title: 'Buses del sistema de transporte retoman sus horarios habituales y regresan los servicios nocturnos',date: '03 de enero de 2020',details: 'La nueva infraestructura, que comienza a funcionar este miércoles 12 de febrero, permitirá a los usuarios transbordar entre l...',image: '/images/news/t13.png',alt: 'TRANSLATIONS.T13'},
      ],
    };
  }

  componentDidMount(){
    window.scrollTo(0,0)
  }


  renderNewsItem = (val) => {
    return (
      <div className="news-item flex-row space-between">
        <div className="news-content font9">
          <div className="news-title bold-text font11">{val.title}</div>
          <div className="news-date">{val.date}</div>
          <div className="news-details">{val.details}</div>
        </div>
        <div className="news-image">
          <img alt={this.props.t(val.alt)} className={val.image == '/images/news/el.png'? "small-icon": ""} src={val.image} />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="pages-press  content-container cancel-done-section font10">
        <div className="cancel-ticket-done font20 page-title">
          {i18next.language == 'es' ? (
            <span className="bold-text">Prensa</span>
          ) : (
            <span className="bold-text">Press</span>
          )}
        </div>
        {i18next.language == 'es' ? (
          <div className="news-subsec">
            Si necesitas contactarte con alguien de kupos.cl o requieres alguna información
            corporativa,
            <br />
            no dudes en escribirnos.
          </div>
        ) : (
          <div className="news-subsec">
            If you want to contact kupos.cl or require any corporate information,
            <br />
            don't hesitate to send us a message.
          </div>
        )}

        <div className="bold-text news-pagetitle font20">
          {i18next.language == 'es' ? 'Contacto de prensa' : 'Press contact'}
        </div>
        <div className="bold-text news-name font13">Cecilia Castro</div>
        <div className="news-marketting">
          {i18next.language == 'es' ? 'Gerente de Operaciones' : 'Chief Operating Officer'}
        </div>
        <div className="news-email">cecilia.castro@pasajebus.com</div>

        <div className="kupos-card news-content">
          {this.state.newsItems.map((val, key) => this.renderNewsItem(val))}
        </div>
      </div>
    );
  }
}

export default withTranslation('common')(Press);


// WEBPACK FOOTER //
// ./src/features/pages/Press.js